import { useAlert } from '@rahtab/ui';
import { NavigationProp, useNavigation } from '@react-navigation/native';
import { RootStackType } from 'components/Router';
import { useEffect, useState } from 'react';
import { SHIPPING_SERVICE_URL } from '../services';
import useToken from './useToken';
import axios from 'axios';

interface CheckRequestData {
  ShipmentId: string;
  vetApprovedCount: number;
  vetApprovedWeight: number;
}

export interface VetApprove {
  isSuccess: boolean;
  message: string;
  comment: string;
  statusCode: number;
}

interface checkOPtions {
  skip: boolean;
}

const url = `${SHIPPING_SERVICE_URL}/verification/approve`;

const useVetApprove = (data: CheckRequestData) => {
  const alert = useAlert();
  const [loading, setLoading] = useState(false);
  const { goBack } = useNavigation<NavigationProp<RootStackType>>();
  const [result, setResult] = useState<VetApprove>();
  const { token, reftech } = useToken();

  const request = () => {
    setLoading(true);
    const { ShipmentId, vetApprovedCount, vetApprovedWeight } = data;
    const body: { ShipmentId: number; vetApprovedCount: number; vetApprovedWeight: number } = {
      ShipmentId: parseFloat(ShipmentId.replace('RNSO-', '')),
      vetApprovedCount,
      vetApprovedWeight,
    };
    axios(url, {
      method: 'POST',
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
        Authorization: 'Bearer ' + token,
      },
      data: body,
      validateStatus: (status) => status < 500,
    })
      .then(async (response) => {
        if (response.status === 401) return reftech();
        if (response.status === 403) return reftech();
        setResult(response.data);
      })
      .catch((error) => {
        console.error(error);
        alert({
          title: 'پیام سیستم',
          message: 'خطا در انجام عملیات لطفا مجددا تلاش نمایید.',
          severity: 'error',
        });
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (!result) return;
    const { isSuccess, message } = result;
    const buttons = [
      {
        color: 'secondary' as const,
        variant: 'outlined' as const,
        text: 'بازگشت',
        onPress: goBack,
      },
    ];
    alert({
      title: 'پیام سیستم',
      message,
      severity: isSuccess ? 'success' : 'error',
      hideBackButton: isSuccess,
      buttons: isSuccess ? buttons : [],
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [result]);

  console.log(result);

  return [request, { loading }] as const;
};

export default useVetApprove;
